<div class="full-width">
	<div class="m-t-1">
		<div fxFlex>
			<div fxLayoutAlign="start center">
				<h3 class="primary-light-color font-weight-normal">Email Routing Guide</h3>
			</div>
		</div>
		<div fxFlex fxLayoutAlign="end center">
			<button color="primary" mat-raised-button (click)="addEmail()">Add email</button>
		</div>
	</div>

	<div class="m-t-1">
		<app-default-progress-bar *ngIf="isLoadingList"></app-default-progress-bar>

		<table [dataSource]="dataSource" class="mat-elevation-z1 full-width" mat-table>
			<ng-container matColumnDef="firstName">
				<th *matHeaderCellDef fxFlex fxLayoutAlign="start center" mat-header-cell>
					<span class="fs-13 color-black"> First Name </span>
				</th>
				<td *matCellDef="let element" fxFlex fxLayoutAlign="start center" mat-cell>
					{{ element?.c4UserDTO?.firstName }}
				</td>
			</ng-container>

			<ng-container matColumnDef="lastName">
				<th *matHeaderCellDef fxFlex fxLayoutAlign="start center" mat-header-cell>
					<span class="fs-13 color-black"> Last Name </span>
				</th>
				<td *matCellDef="let element" fxFlex fxLayoutAlign="start center" mat-cell>
					{{ element?.c4UserDTO?.lastName }}
				</td>
			</ng-container>

			<ng-container matColumnDef="email">
				<th *matHeaderCellDef fxFlex fxLayoutAlign="start center" mat-header-cell>
					<span class="fs-13 color-black"> Email </span>
				</th>
				<td *matCellDef="let element" fxFlex fxLayoutAlign="start center" mat-cell>
					{{ element?.c4UserDTO?.email }}
				</td>
			</ng-container>

			<ng-container matColumnDef="state">
				<th *matHeaderCellDef fxFlex fxLayoutAlign="start center" mat-header-cell>
					<span class="fs-13 color-black"> State </span>
				</th>
				<td *matCellDef="let element" fxFlex fxLayoutAlign="start center" mat-cell>
					{{ element.state }}
				</td>
			</ng-container>

			<ng-container matColumnDef="createdAt">
				<th *matHeaderCellDef fxFlex fxLayoutAlign="start center" mat-header-cell>
					<span class="fs-13 color-black"> Created At </span>
				</th>
				<td *matCellDef="let element" fxFlex fxLayoutAlign="start center" mat-cell>
					{{ element.createdAt | date: 'MM/dd/yyyy' }}
				</td>
			</ng-container>

			<ng-container matColumnDef="updatedAt">
				<th *matHeaderCellDef fxFlex fxLayoutAlign="start center" mat-header-cell>
					<span class="fs-13 color-black"> Updated At </span>
				</th>
				<td *matCellDef="let element" fxFlex fxLayoutAlign="start center" mat-cell>
					{{ element.updatedAt | date: 'MM/dd/yyyy' }}
				</td>
			</ng-container>

			<ng-container matColumnDef="actions">
				<th *matHeaderCellDef fxFlex fxLayoutAlign="start center" mat-header-cell>
					<span class="fs-13 color-black"></span>
				</th>
				<td *matCellDef="let element" fxFlex fxLayoutAlign="start center" mat-cell>
					<mat-icon (click)="deleteAccountEmail(element)" class="danger-text m-r-1 cursor-pointer">
						delete_forever
					</mat-icon>
					<mat-icon (click)="editAccountEmail(element)" class="primary-light-color cursor-pointer">
						edit
					</mat-icon>
				</td>
			</ng-container>
			<tr *matHeaderRowDef="displayedColumns" mat-header-row></tr>
			<tr *matRowDef="let row; columns: displayedColumns" class="row-hover" mat-row></tr>
		</table>
	</div>

	<mat-card *ngIf="!isLoadingList && dataSource?.data?.length === 0" class="mat-elevation-z0 br-0">
		<mat-card-content fxLayoutAlign="center center">
			<h4 class="primaryTextColor" color="primary">No data available.</h4>
		</mat-card-content>
	</mat-card>

	<mat-paginator
		(page)="getAccountEmailMaps()"
		[length]="totalRecords"
		[pageSizeOptions]="[PAGE_SIZE]"
		class="mat-elevation-z1"
		showFirstLastButtons
	>
	</mat-paginator>
</div>
